import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const StyledRootBox = styled(Box)`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  background: ${Colors.white};
  border: 1px solid ${Colors.neutral_gray_300};
  box-shadow: ${Colors.Elevation_2};
  border-radius: 12px;
  min-height: inherit;
`;

export const StyledRowBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const StyledTypography = styled(Typography)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 26px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.primary};
`;

export const StyledSalesRow = styled(Box)`
  display: flex !important;
  gap: 8px;
`;

export const StyledBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 25px !important;
`;
